import { __decorate } from "tslib";
import { ApiResource } from '../../lib/api-decorators';
import { Api } from '../../lib/api.factory';
let ReportResource = class ReportResource extends Api {
    getReport(project, date) {
        return this.get('/', { project, date });
    }
    create(project, date) {
        return this.post('/', { project, date });
    }
    publish(project, date) {
        return this.put('/publish', { project, date });
    }
    schedule(project, date) {
        return this.put('/schedule', { project, date });
    }
    unschedule(project, date) {
        return this.put('/unschedule', { project, date });
    }
    getList(project, pagination) {
        return this.get('/list', Object.assign(Object.assign({}, pagination), { project }));
    }
    getItemCounts(project, date) {
        return this.get('/item-counts', { project, date });
    }
};
ReportResource = __decorate([
    ApiResource('/report')
], ReportResource);
export { ReportResource };
